import clientApi from 'clientApi';
import { getCoupons, getRoPayments, getSettings, handleError } from 'redux/actions/dashboard/index';
import { getRewardsTiers } from 'redux/actions/dashboard/rewards';

// GET ROs by customer - endpoint cannot return other customers' ROs
export const getRos = (primaryCustomerId) => async (dispatch, getState) => {
  if (getState().dashboard.gettingRO) return;

  dispatch({ type: 'GET_ROS' });

  try {
    const { data } = await clientApi.getRos({
      sortField: 'dateCreated',
      sortDirection: 'DESC',
      primaryCustomerId,
      // TODO: if BE supports pagination, FE should implment infinite loading.
      pageLimit: 20,
    });

    dispatch({ type: 'RECEIVE_ROS', data });
    return data;
  } catch (err) {
    dispatch(handleError(err));
    return false;
  }
};
// The quote read can fail on its own (it syncs from the DMS on first open), and the payment, video,
// and coupon cards don't depend on it — so a quote failure is reported without aborting the rest of
// the RO load. Otherwise a customer opening a payment link sees an empty bill (ISA-4947).
const getRepairOrderQuote = (repairOrderQuoteId) => async (dispatch) => {
  let quoteData;
  try {
    ({ data: quoteData } = await clientApi.getQuote(repairOrderQuoteId));
  } catch (err) {
    dispatch(handleError(err));
    return;
  }
  dispatch({ type: 'RECEIVE_QUOTE', data: quoteData });
};

export const getRO = () => async (dispatch, getState) => {
  if (getState().dashboard.gettingRO) return;
  dispatch({ type: 'GET_RO' });

  let data;
  try {
    ({ data } = await clientApi.getRO());
  } catch (err) {
    dispatch(handleError(err));
    return;
  }

  dispatch({ type: 'RECEIVE_RO', data });
  // The quote must land before the payments are requested: the legacy quote card auto-opens the
  // Pricing Estimate when the quote arrives and the payment card auto-opens its modal when the
  // payments arrive, and the modal mounted last sits on top. A customer opening a payment link must
  // see the payment modal, not the estimate (ISA-4947).
  if (data.repairOrderQuoteId) {
    await dispatch(getRepairOrderQuote(data.repairOrderQuoteId));
  }
  dispatch(getSettings());
  dispatch(getVideos(data.id));
  dispatch(getCoupons());
  dispatch(getRoPayments(data.id));

  if (data.repairOrderMultiPointInspectionStatus === 'Complete') {
    dispatch(getMpiMedia(data.id));
  }

  if (data.primaryCustomer?.customerRewards) {
    dispatch(getRewardsTiers());
  }
};
export const startPollingRO = () => (dispatch) => {
  dispatch(getRO());

  console.log('NOT POLLING');
  // const roPollingInterval = setInterval(() => {
  //     dispatch(getRO());
  // }, 30000);
  // dispatch({ type: 'START_POLLING_RO', roPollingInterval });
};
export const stopPollingRO = () => {
  return (dispatch) => {
    dispatch({ type: 'STOP_POLLING_RO' });
  };
};

export const getVideos = (roId) => async (dispatch) => {
  try {
    const { data } = await clientApi.getVideos(roId);

    dispatch({ type: 'RECEIVE_VIDEOS', data });
  } catch (err) {
    dispatch(handleError(err));
  }
};

export const getMpiMedia = (roId) => async (dispatch) => {
  try {
    const { data } = await clientApi.getMpi(roId);
    dispatch({ type: 'RECEIVE_MPI_MEDIA', data: data.repairOrderMedia });
  } catch (err) {
    dispatch(handleError(err));
  }
};
